{
  "api_url": "https://api.bisom.fr/",
  "sentry": {
    "dsn": "https://e4628cf9c8b341dc9001d62537f02c40@glitchtip.bisom.fr/7",
    "environment": "production",
    "debug": false,
    "sample_rate": 1.0
  }
}
